import { Typography, Theme } from '@mui/material';
import cnames from 'classnames';
import WarningIcon from '@mui/icons-material/ReportProblemOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import GVTooltip from 'components/lib/GVToolTip/GVTooltip';
import { makeStyles } from 'tss-react/mui';
import styles from './TabLabel.module.css';

const useStyles = makeStyles()((theme: Theme) => ({
  warningIcon: {
    color: theme.palette.warning.main,
  },
}));

interface TabsLabelProps {
  label: string;
  warning?: boolean;
  tooltipTitle?: (string | JSX.Element)[] | string;
  disabled?: boolean;
  showLock?: boolean;
  fontSize?: string;
}

const TabLabel = (props: TabsLabelProps) => {
  const { classes } = useStyles();
  return (
    <div className={styles.root}>
      {props.showLock && (
        <LockOutlinedIcon className={cnames(styles.lock, props.disabled ? styles.lockDisabled : styles.lockEnabled)} />
      )}
      <Typography
        className={cnames({ [styles.disabled]: props.disabled })}
        variant="button"
        sx={props.fontSize ? { fontSize: props.fontSize } : undefined}
      >
        {props.label}
      </Typography>
      {props.warning && (
        <GVTooltip title={props.tooltipTitle ?? ''}>
          <WarningIcon className={classes.warningIcon} />
        </GVTooltip>
      )}
    </div>
  );
};

export default TabLabel;
